// extracted by mini-css-extract-plugin
export default {"container":"style_container__NaCS6","errorCode":"style_errorCode__krtTq","text":"style_text__bqY+n","returnText":"style_returnText__i6ELZ"};